export default __webpack_public_path__ + "static/media/img-0445-luxembourg-full-face.c983b98d.png";